import React from 'react';
import useContactLogic from './hooks/useContactLogic';
import ContactDesktop from './components/ContactDesktop';
import ContactMobile from './components/ContactMobile';

function Contact() {
  const { screenSize, ...rest } = useContactLogic();

  return screenSize === 'mobile' ? (
    <ContactMobile {...rest} />
  ) : (
    <ContactDesktop {...rest} />
  );
}

export default Contact;
